import {
  ReleaseNotesService,
  ReleaseFeatureIdentifiersByDate
} from "../../sdServices/release-notes-config/release-notes-service";
import { ReleaseNotesByAppId, ReleaseNote } from "../../sdServices/release-notes-config/release-notes-config";
import {
  ReleaseNotesViewStates,
  ReleaseNotesSetting
} from "../../sdServices/release-notes-config/release-notes-service";
import { CustomKeyValues, TelemetryService } from "../../../ShellCommon/logger/telemetry-service";
import { GlobalTelemetryConstants } from "../../../ShellCommon/logger/telemetry-constants";
import * as ReleaseNotesTelemetryConstants from "../../Constants/ReleaseNotesTelemetryConstants";
import { DialogService } from "../../sdServices/dialog";
import { SettingsWindowService } from "../../sdServices/settings-window-service";
export class SdReleaseNoteSplashController {
  public isChecked: boolean;
  public allUnviewedFeatures: ReleaseNotesByAppId;
  public dateCreated: Date;
  public releaseNoteSetting: ReleaseNotesSetting;
  public showPreviousDetailFooter: boolean;
  private originalReleaseNoteViewStates: ReleaseNotesViewStates;

  // @ngInject
  constructor(
    private dialogService: DialogService,
    private releaseNotesService: ReleaseNotesService,
    private settingsWindowService: SettingsWindowService,
    private telemetryService: TelemetryService,
    private telemetryConstants: GlobalTelemetryConstants
  ) {
    this.isChecked = this.releaseNoteSetting ? this.releaseNoteSetting.ifShowDetails === "true" : true;
    this.releaseNotesService
      .getAllActiveReleasedFeatureIdentifiersByDate()
      .then((releasedFeatures: ReleaseFeatureIdentifiersByDate) => {
        this.showPreviousDetailFooter = releasedFeatures.length > 1;
      });
  }

  /**
   * Saves the viewed state to the preferences service, closes the splash dialog, and opens up a
   * new window with detailed notes if show detailed checkbox is selected
   */
  public closeSplash(): void {
    let updatedViewStates = this.convertReleaseNotesToViewed(this.allUnviewedFeatures);
    updatedViewStates = this.mergeReleaseNotesViewState(this.originalReleaseNoteViewStates, updatedViewStates);
    this.releaseNoteSetting.ifShowDetails = this.isChecked.toString();
    this.releaseNotesService.saveReleaseNotesViewedState(updatedViewStates, this.releaseNoteSetting).finally(() => {
      let metaTags: CustomKeyValues = {};
      if (this.isChecked) {
        this.openReleaseNotesInSettingsWindow();
        if (!this.releaseNotesService.isRecentSplashForced()) {
          metaTags[this.telemetryConstants.pageMetadataTags.scenario] =
            ReleaseNotesTelemetryConstants.RELEASE_NOTES_TELEMETRY_APP_ID +
            "." +
            ReleaseNotesTelemetryConstants.RELEASE_NOTES_TELEMETRY_SCENARIO.SPLASH;

          metaTags[this.telemetryConstants.pageMetadataTags.scenarioStep] =
            ReleaseNotesTelemetryConstants.RELEASE_NOTES_TELEMETRY_APP_ID +
            "." +
            ReleaseNotesTelemetryConstants.RELEASE_NOTES_TELEMETRY_SCENARIO.SPLASH +
            "." +
            ReleaseNotesTelemetryConstants.RELEASE_NOTES_TELEMETRY_SCENARIO_STEP.OPEN_RELEASE_DETAILS_CHECKBOX;

          let data: CustomKeyValues = {};
          data["openTimeSettingsFromCheckbox"] = String(new Date());

          this.telemetryService.pushPageActionEvent(
            this.telemetryConstants.pageActionType.click,
            this.telemetryConstants.pageActionBehavior.Navigate,
            metaTags,
            data
          );
        }
      }
      this.dialogService.hide();
      const splashClose: any = new Date();
      if (!this.releaseNotesService.isRecentSplashForced()) {
        metaTags = {};
        metaTags[this.telemetryConstants.pageMetadataTags.scenario] =
          ReleaseNotesTelemetryConstants.RELEASE_NOTES_TELEMETRY_APP_ID +
          "." +
          ReleaseNotesTelemetryConstants.RELEASE_NOTES_TELEMETRY_SCENARIO.SPLASH;

        metaTags[this.telemetryConstants.pageMetadataTags.scenarioStep] =
          ReleaseNotesTelemetryConstants.RELEASE_NOTES_TELEMETRY_APP_ID +
          "." +
          ReleaseNotesTelemetryConstants.RELEASE_NOTES_TELEMETRY_SCENARIO.SPLASH +
          "." +
          ReleaseNotesTelemetryConstants.RELEASE_NOTES_TELEMETRY_SCENARIO_STEP.SPLASH_CLOSED;

        let data: CustomKeyValues = {};

        const splashDwellTime = splashClose - this.releaseNotesService.splashOpenTime;
        const splashDwellTimeSeconds = splashDwellTime / 1000;

        data["splashDwellTimeSeconds"] = String(splashDwellTimeSeconds);

        this.telemetryService.pushPageActionEvent(
          this.telemetryConstants.pageActionType.click,
          this.telemetryConstants.pageActionBehavior.Navigate,
          metaTags,
          data
        );
      }
      this.releaseNotesService.setReleaseNoteSplashObservable(false);
    });
  }

  public openReleaseNotesInSettingsWindow() {
    this.settingsWindowService.openPivotInSettingsWindow("release_notes");
  }

  public openSettingsFromClickHereCallback() {
    let metaTags: CustomKeyValues = {};
    metaTags[this.telemetryConstants.pageMetadataTags.scenario] =
      ReleaseNotesTelemetryConstants.RELEASE_NOTES_TELEMETRY_APP_ID +
      "." +
      ReleaseNotesTelemetryConstants.RELEASE_NOTES_TELEMETRY_SCENARIO.SPLASH;

    metaTags[this.telemetryConstants.pageMetadataTags.scenarioStep] =
      ReleaseNotesTelemetryConstants.RELEASE_NOTES_TELEMETRY_APP_ID +
      "." +
      ReleaseNotesTelemetryConstants.RELEASE_NOTES_TELEMETRY_SCENARIO.SPLASH +
      "." +
      ReleaseNotesTelemetryConstants.RELEASE_NOTES_TELEMETRY_SCENARIO_STEP.OPEN_RELEASE_DETAILS_LINK;

    let data: CustomKeyValues = {};
    data["openTimeSettingsFromLink"] = String(new Date());

    this.telemetryService.pushPageActionEvent(
      this.telemetryConstants.pageActionType.click,
      this.telemetryConstants.pageActionBehavior.Navigate,
      metaTags,
      data
    );
  }

  private convertReleaseNotesToViewed(viewedFeatures: ReleaseNotesByAppId): ReleaseNotesViewStates {
    const releaseNotesViewedState: ReleaseNotesViewStates = {};

    Object.keys(viewedFeatures).forEach((appId: string) => {
      const viewedState: { [featureId: string]: boolean } = {};
      viewedFeatures[appId].forEach((releaseNote: ReleaseNote) => {
        viewedState[releaseNote.featureId] = true;
      });

      releaseNotesViewedState[appId] = viewedState;
    });

    return releaseNotesViewedState;
  }

  private mergeReleaseNotesViewState(
    viewState1: ReleaseNotesViewStates,
    viewState2: ReleaseNotesViewStates
  ): ReleaseNotesViewStates {
    const mergedViewState: ReleaseNotesViewStates = {};
    const allAppIds: string[] = Object.keys(Object.assign({}, viewState1, viewState2));
    allAppIds.forEach((appId: string) => {
      mergedViewState[appId] = Object.assign({}, viewState1[appId], viewState2[appId]);
    });
    return mergedViewState;
  }
}

export const sdReleaseNoteSplash: ng.IComponentOptions = {
  controller: SdReleaseNoteSplashController,
  bindings: {
    allUnviewedFeatures: "<",
    originalReleaseNoteViewStates: "<",
    releaseNoteSetting: "<",
    dateCreated: "<"
  },
  templateUrl: "../ServiceDesk/releaseNotes/splash/sd-release-note-splash.html"
};
